import { ICustomerVehicle } from "JS/types/Automotive";
import { objectToQueryString, QueryStringableObject } from "JS/utilities/url";

export function getVehicleTireListLink(vehicle: Pick<ICustomerVehicle, 'id' | 'tireSizeDescription'>, additionalQueryParams: QueryStringableObject = {}): string {
	return `/tires/list?${objectToQueryString({
		customerVehicleId: vehicle.id,
		sizeDescription: vehicle.tireSizeDescription,
		...additionalQueryParams,
	})}`;
}